import React from 'react'

const Not = () => {
  return (
    <div>404 Error</div>
  )
}

export default Not